import { createSelector } from 'reselect';
import { ActionReducer, MetaReducer, ActionReducerMap } from '@ngrx/store';
import { storeLogger } from 'ngrx-store-logger';

import {
  getItems,
  getItemsTotalCount,
  getCriteria,
  getIndex,
  getDeleting,
  getViewType,
  getSelectedIds,
  getSelectedItems,
  IEntityState,
  getEntityReducer,
  getQueryParams,
  getRouteParams,
  getIsSingleMode,
  IRouterState,
  globalReducer,
} from '@kpd/framework-ngx';

//
// meta reducers
//
export function logger(reducer: ActionReducer<IAppState>): any {
  // default, no options
  return storeLogger()(reducer);
}

// combine with other mete reducers
export const metaReducers: MetaReducer<IAppState>[] = [
  logger,
  /* add more meta reducers here */
];

//
// selectors
//

export const getRouterState = (state: IAppState) => state.router;

export const getEntityItems = getItems;
export const getEntityItemsTotal = getItemsTotalCount;
export const getEntityCriteria = getCriteria;
export const getEntityIndex = getIndex;
export const getEntityDeleting = getDeleting;
export const getEntityViewType = getViewType;
export const getEntitySelectedIds = getSelectedIds;
export const getEntitySelectedItems = getSelectedItems;

export const getRouterQueryParams = createSelector(getRouterState, getQueryParams);
export const getRouterRouteParams = createSelector(getRouterState, getRouteParams);
export const getRouterIsSingleMode = createSelector(getRouterState, getIsSingleMode);

//
// state
//
export interface IAppState {
  users: IEntityState;
  roles: IEntityState;
  licenses: IEntityState;
  permissionSets: IEntityState;
  router: IRouterState;
}

// reason: we need to provide the reducers using a injectiontoken, due by the restrictions that function expressions can not be used in decoraters.
// More info cfr.: URL: https://github.com/ngrx/platform/blob/master/docs/store/api.md#injecting-reducers
export function getReducers(): ActionReducerMap<IAppState> {
  const reds: any = {
    users: getEntityReducer('users'),
    licenses: getEntityReducer('licenses'),
    roles: getEntityReducer('roles'),
    permissionSets: getEntityReducer('permissionSets'),
    permissions: getEntityReducer('permissions'),
    router: globalReducer,
  };
  return reds;
}
